var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history-bg",staticStyle:{"padding":"0","height":"100%","width":"100%","position":"relative"}},[_c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":"sqOne"}})])
}]

export { render, staticRenderFns }